<!--
 * @Author: your name
 * @Date: 2021-06-26 16:38:14
 * @LastEditTime: 2021-07-19 16:18:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\ToolsList\ToolVideo.vue
-->
<!--视频-->

<template>
  <div class="tool-video">
    <img v-if="isSaveProgram" class="field-media" :src="media.ext_val_pimg" alt />
    <video
      v-else
      class="field-media"
      :class="{'scale-type':!media.ext_val_scaleType}"
      :src="media.field_item_path"
      autoplay
      loop
      muted
    />
  </div>
</template>

<script>
export default {
  name: "ToolVideo",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    isSaveProgram() {
      return this.$store.state.program.isSaveProgram;
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-video {
  width: 100%;
  height: 100%;
  background: #000;
  .field-media {
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  .scale-type {
    object-fit: fill;
  }
}
</style>